import { render, staticRenderFns } from "./Offset.vue?vue&type=template&id=6493b539"
import script from "./Offset.vue?vue&type=script&lang=ts"
export * from "./Offset.vue?vue&type=script&lang=ts"
import style0 from "./Offset.vue?vue&type=style&index=0&id=6493b539&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports